<template>
  <div>
    <div class="subscription-container">
      <section v-if="programsToShow.dpt">
        <p class="t3 -mt_0 -t_semi-bold">
          {{ $t('subscription_center_dpt') }}
        </p>
        <sword-checkbox-wuk
          v-model="programs.dpt"
          :opt-value="programs.dpt"
          :label="$t('subscription_center_dpt')"
          :show-error="false"
          @change="handleSubscriptionChange(UNITS.DPT, $event)"
        >
          {{ $t('subscription_center_dpt_description') }}
        </sword-checkbox-wuk>
      </section>
      <section v-if="programsToShow.bloom">
        <p class="t3 -mt_0 -t_semi-bold">
          {{ $t('subscription_center_bloom') }}
        </p>
        <sword-checkbox-wuk
          v-model="programs.bloom"
          :show-error="false"
          :opt-value="programs.bloom"
          @change="handleSubscriptionChange(UNITS.BLOOM, $event)"
        >
          {{ $t('subscription_center_bloom_description') }}
        </sword-checkbox-wuk>
      </section>
      <section v-if="programsToShow.move">
        <p class="t3 -mt_0 -t_semi-bold">
          {{ $t('subscription_center_move') }}
        </p>
        <sword-checkbox-wuk
          v-model="programs.move"
          :opt-value="programs.move"
          :show-error="false"
          @change="handleSubscriptionChange(UNITS.MOVE, $event)"
        >
          {{ $t('subscription_center_move_description') }}
        </sword-checkbox-wuk>
      </section>
    </div>
    <section class="subscription-center--container-disclaimer">
      <i18n path="subscribe_center_unsubscribe_all_new" tag="span" class="subscription-center-unsubscribe-all-text">
        <template #unsubscribe>
          <sword-link :to="unsubscribeAllUnitsLink()" :text="$t('subscribe_center_unsubscribe_all_link_new')">
          </sword-link>
        </template>
      </i18n>
      <div class="subscription-screen-note-text">
        <span><sup>1 </sup>{{ $t('subscription_center_general_disclaimer') }}</span>
      </div>
    </section>
  </div>
</template>

<script>
import SwordCheckboxWuk from '@ui-kit/components/inputs/checkboxes/SwordCheckbox.vue';
import SwordLink from '@ui-kit/components/links/SwordLink.vue';
import marketingIntegrationService from '@/services/MarketingIntegrationService';
import { CONFIGURATIONS } from '@/scripts/constants/configurations';

export default {
  name: 'SubscriptionCenterScreen',
  components: { SwordCheckboxWuk, SwordLink },
  data() {
    return {
      UNITS: { ...CONFIGURATIONS },
      leadSubscriptions: [],
      programsToShow: {
        dpt: false,
        bloom: false,
        move: false,
      },
      programs: {
        dpt: false,
        bloom: false,
        move: false,
      },
      leadUUID: '',
    };
  },
  beforeMount() {
    const { leadUUID } = this.$route.params;
    this.leadUUID = leadUUID;
  },
  async mounted() {
    this.$zendesk.setZendeskStrictMode(true);
    this.setPageInfo();
    await this.getChannelsByLeadID(this.leadUUID);
  },
  methods: {
    unsubscribeAllUnitsLink() {
      return `/subscriptions-center/${this.leadUUID}/process`;
    },
    handleSubscriptionChange(unit, check) {
      if (!check) {
        this.unsubscribeByUnit(this.leadUUID, unit);
      }

      if (check) {
        this.subscribeLeadByUnit(this.leadUUID, unit);
      }
    },
    setPageInfo() {
      this.$pageInfo.isLoading = true;
      this.$pageInfo.title = 'subscription_center_title';
      this.$pageInfo.subTitle = 'subscription_center_subtitle';
    },
    checkSubscriptions(subscriptions) {
      subscriptions.forEach(subscriptionUnit => {
        if (Object.hasOwn(this.programs, subscriptionUnit.channel)) {
          this.programs[subscriptionUnit.channel] = subscriptionUnit.active;
          this.programsToShow[subscriptionUnit.channel] = true;
        }
      });
    },
    async subscribeLeadByUnit(leadUUID, unit) {
      try {
        await marketingIntegrationService.subscribeLeadByUnit(leadUUID, unit);
        this.getSuccessToastMessage();
      } catch (error) {
        this.getErrorToastMessage(error);
      }
    },
    async unsubscribeByUnit(leadUUID, unit) {
      try {
        await marketingIntegrationService.unsubscribeLead(leadUUID, unit);
        this.getSuccessToastMessage();
      } catch (error) {
        this.getErrorToastMessage();
      }
    },
    async unsubscribeAllUnits() {
      try {
        await this.$router.push({ name: 'SubscriptionProcess' });
      } catch (error) {
        this.getErrorToastMessage();
      }
    },
    async getChannelsByLeadID(leadUUID) {
      try {
        const { subscriptions } = await marketingIntegrationService.getChannelsByLeadID(leadUUID);
        this.checkSubscriptions(subscriptions);
        this.$pageInfo.isLoading = false;
      } catch (error) {
        this.getErrorToastMessage();
      }
    },
    goToError() {
      this.$router.push({ name: 'SubscriptionError' });
    },
    goToSuccess() {
      this.$router.push({ name: 'SubscriptionSuccess' });
    },
    getSuccessToastMessage() {
      this.$notify.success(this.$t('subscription_center_success_notification'), { timeout: 1500, style: 'font-size: 0.87em; text-align: center;' });
    },
    getErrorToastMessage() {
      this.$notify.error(this.$t('onboarding_message_something_went_wrong'), { timeout: 1500, style: 'font-size: 0.87em; text-align: center;' });
    },
  },
};
</script>
<style lang="scss" scoped>
.subscription-container {
  @extend %flex-column;
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
  text-align: start;
  flex: 1;
  gap: 2rem;
}

.subscription-center--container-disclaimer {
  margin: 15px 0;
}
.subscription-center-unsubscribe-all-text {
  display: block;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  color: $context-color-3;
  &::v-deep {
    a {
      @extend %-t_semi-bold;
      color: $primary-color;
    }
  }
}

.subscription-screen-note-text {
  text-align: initial;
  font-size: 12px;
  color: $context-color-3;
}
</style>
